export const LABELS = {
	DOWNLOAD_CSV: 'Download CSV'
};

export const WFA_SESSION_ALL_ISSUES_CSV_HEADERS = {
	ISSUE_TYPE: 'Issue Type',
	SEVERITY: 'Severity',
	SELECTOR: 'Selector',
	URL: 'URL',
	PAGE_TITLE: 'Page Title'
};
